import { Button } from '@winnin/winnin_ui.components.button'
import { InputWithLabel } from '@winnin/winnin_ui.components.input-with-label'
import { Modal } from '@winnin/winnin_ui.components.modal'
import { Title } from '@winnin/winnin_ui.components.title'

import { ReactComponent as TopicOverview } from 'assets/images/svg/dashboardComponents/topic.svg'
import { BaseSkeleton } from 'components/BaseSkeleton'
import { useTranslate } from 'lib/tolgee'
import { DashboardFolder } from 'modules/dashboard'
import { MODAL_STYLE } from 'modules/dashboard/common/dashboard.consts'
import { TOLGEE_GLOBALS } from 'utils'

import { translations } from './select-dashboard-folder-modal.i18n'
import type { TSelectDashboardFolderModalViewProps } from './select-dashboard-folder-modal.types'
import './select-dashboard-folder-modal.styles.scss'

export const SelectDashboardFolderModalView = ({
  handleClose,
  isSubmitDisabled,
  isOpen,
  foldersList,
  handleSelectFolder,
  selectedFolder,
  hasMore,
  sentryRef,
  loading,
  handleSubmit,
  handleInputChange,
  inputValue,
  isEmpty,
}: TSelectDashboardFolderModalViewProps) => {
  const t = useTranslate()

  return (
    <Modal style={MODAL_STYLE} isOpen={isOpen} onRequestClose={handleClose}>
      <div className="SelectDashboardFolderModal">
        <Title tag="h2">{t(translations.selectFolder)}</Title>
        <InputWithLabel placeholder={t(TOLGEE_GLOBALS.search)} onChange={handleInputChange} value={inputValue} />
        <div className="SelectDashboardFolderModal-foldersList">
          {foldersList.map(item => {
            return (
              <button key={item.id} onClick={() => handleSelectFolder(item)}>
                <DashboardFolder
                  dashboardCount={item.dashboardCount}
                  folderName={item.folderName}
                  isSelected={item.id === selectedFolder?.id}
                />
              </button>
            )
          })}
          {isEmpty && (
            <div className="SelectDashboardFolderModal-emptyState">
              <Title tag="h3">{t(translations.noFolders)}</Title>
              <TopicOverview height="224px" width="241px" />
            </div>
          )}
          {loading &&
            Array.from({ length: 5 }).map((_, index) => {
              return <BaseSkeleton height="74px" width="431px" borderRadius="12px" key={index} />
            })}
          {hasMore && (
            <div ref={sentryRef}>
              <BaseSkeleton height="74px" width="431px" borderRadius="12px" />
            </div>
          )}
        </div>
        <div className="SelectDashboardFolderModal-buttonsSection">
          <Button appearance="link" onClick={handleClose}>
            {t(TOLGEE_GLOBALS.cancel)}
          </Button>
          <Button disabled={isSubmitDisabled} onClick={handleSubmit}>
            {t(TOLGEE_GLOBALS.save)}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
